export const policyType = {
    privacyPolicy: 1,
    termsOfService: 2,
    dataProcessingAgreement: 3,
    serviceLevelAgreement: 4,
}
